const CashStatusType = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED'
}

export default CashStatusType;